import { useEffect, useState } from 'react';
import CustomAppBar from '../../components/CustomAppBar';
import { alpha, Box, Button, Card, CircularProgress, Container, darken, Fab, Grid, IconButton, ImageList, ImageListItem, lighten, LinearProgress, Typography, useTheme } from "@mui/material";
import { AddIcCallOutlined, Close, CloseOutlined, GraphicEq, PlayArrow, PlayArrowOutlined, PlayArrowRounded, StarBorderOutlined } from '@mui/icons-material';
import { connect, useDispatch } from 'react-redux';
import { authActions } from '../../store/reducer/auth-reducer';
import { homePageActions } from '../../store/reducer/home';
import { starlineActions } from '../../store/reducer/starline';
import { useNavigate } from 'react-router-dom';
import AlertBar from '../../components/AlertBar';
import { Call, Refresh, Telegram, WhatsApp } from "@mui/icons-material";
import { ReactComponent as StarGameIcon } from '../../assets/star-fall-svgrepo-com.svg';
import { ReactComponent as PlayIcon } from '../../assets/play-square-svgrepo-com.svg';
import { ReactComponent as TimerIcon } from '../../assets/timer-start-svgrepo-com.svg';
import { ReactComponent as ContactUs } from '../../assets/support-svgrepo-com.svg';
import { ReactComponent as AddFundIcon } from '../../assets/wallet-receive-svgrepo-com.svg';
import { ReactComponent as WithdrawFundIcon } from '../../assets/wallet-send-svgrepo-com.svg';
import { ReactComponent as InfoIcon } from '../../assets/info-square-svgrepo-com.svg';
import AddIcon from '@mui/icons-material/Add';
import CustomModal from '../../components/CustomModal';

import { ReactComponent as OpenIcon } from '../../assets/check-square-svgrepo-com.svg';
import { ReactComponent as CloseIcon } from '../../assets/close-square-svgrepo-com.svg';
import { get, isEmpty } from 'lodash';
import DocumentTitle from '../../components/DocumentTitle';
import { useAddToHomescreenPrompt } from '../../components/useAddToHomescreenPrompt';



const Home = ({ homePageData, isHomeLoading, sliderData, isCheckGameStatusLoading, gameStatusData, isCheckGameStatusFailed, isCheckGameStatusSuccess, contactData, isStarLineLoading, starLineData }: any) => {
    const userDataSession: any = localStorage.getItem('userData');
    const finalData = JSON.parse(userDataSession)
    const theme = useTheme();
    const [pageData, setPageData] = useState<any>([])
    const [starlineGames, setStarlineGames] = useState<any>([])
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [errorMessage, setErrorMessage] = useState<any>({ status: false, message: '', severity: '', inputName: '' })
    const [selectedItem, setSelectedItem] = useState<any>({});
    const [openModal, setOpenModal] = useState<any>(false);
    const [currentTime, setCurrentTime] = useState(new Date());

    const [prompt, promptToInstall, isInstalled] = useAddToHomescreenPrompt();
    const [isVisible, setVisibleState] = useState(false);

    const hide = () => setVisibleState(false);

    useEffect(
        () => {
            // Only show the icon if:
            // 1. Prompt is available (browser allows installation)
            // 2. App is NOT already installed
            if (prompt && !isInstalled) {
                setVisibleState(true);
            } else {
                setVisibleState(false);
            }
        },
        [prompt, isInstalled]
    );

    useEffect(() => {
        const data: any = {
            app_key: "@34Y@#8deepmatka",
            user_id: 0,
            player_id: 0
        };
        dispatch(homePageActions.dashboardDataRequest(data))
        dispatch(homePageActions.sliderDataRequest(data))
        const datacon: any = { "app_key": "@34Y@#8deepmatka" }
        dispatch(homePageActions.contactDataRequest(datacon))
        
        // Fetch Starline games
        const starlineData: any = {
            app_key: "@34Y@#8deepmatka",
        };
        dispatch(starlineActions.starLineDataReq(starlineData))
        
        document.title = 'Home Page';
        const pay: any = {
            menuname: 'home'
        }
        dispatch(homePageActions.selectedMenu(pay))

    }, [])

    useEffect(() => {
        if (Object.keys(homePageData).length) {
            setPageData(homePageData.result)
        }
    }, [homePageData, isHomeLoading])

    useEffect(() => {
        if (!isEmpty(starLineData) && starLineData.result) {
            setStarlineGames(starLineData.result)
        }
    }, [starLineData, isStarLineLoading])

    // Update current time every second for countdown timer
    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentTime(new Date());
        }, 1000);
        return () => clearInterval(timer);
    }, []);

    // Function to calculate remaining time until result time
    const getRemainingTime = (resultTime: string) => {
        if (!resultTime) return null;
        
        try {
            const today = currentTime; // Use currentTime state that updates every second
            const [time, period] = resultTime.split(' ');
            const [hours, minutes] = time.split(':');
            
            let resultHour = parseInt(hours);
            const resultMinute = parseInt(minutes);
            
            // Convert to 24-hour format
            if (period === 'PM' && resultHour !== 12) {
                resultHour += 12;
            } else if (period === 'AM' && resultHour === 12) {
                resultHour = 0;
            }
            
            // Create target date for today
            const targetDate = new Date(today);
            targetDate.setHours(resultHour, resultMinute, 0, 0);
            
            // If target time has passed today, set it for tomorrow
            if (targetDate <= today) {
                targetDate.setDate(targetDate.getDate() + 1);
            }
            
            const diff = targetDate.getTime() - today.getTime();
            
            if (diff <= 0) return null;
            
            const hoursLeft = Math.floor(diff / (1000 * 60 * 60));
            const minutesLeft = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
            const secondsLeft = Math.floor((diff % (1000 * 60)) / 1000);
            
            return {
                hours: hoursLeft,
                minutes: minutesLeft,
                seconds: secondsLeft,
                formatted: `${String(hoursLeft).padStart(2, '0')}:${String(minutesLeft).padStart(2, '0')}:${String(secondsLeft).padStart(2, '0')}`
            };
        } catch (error) {
            return null;
        }
    };

    const handleStarlineGameClick = (event: any, item: any) => {
        setSelectedItem(item);
        if (item.msg_status === 1) {
            navigate('/starline/game-list/' + item.game_id)
        } else {
            setErrorMessage({ status: true, message: "Game is closed for today.", severity: 'error', inputName: '' })
        }
    }

    const handleClose = (event: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }

        setErrorMessage({ status: false, message: "", severity: "", inputName: '' })
    };

    const openPopup = () => {
        setOpenModal(true)
    }


    const closePopup = () => {
        setOpenModal(false)
    }

    const openLoginCheckPages = (type: any) => {
        if (isEmpty(finalData)) {
            setErrorMessage({ status: true, message: "Login required.", severity: "warning", inputName: '' })
        } else {
            if (type === 'addpoints') {
                navigate('/add-point')
            } else {
                navigate('/withdraw-points')
            }
        }

    }

    const handleRefresh = () => {
        const data: any = {
            app_key: "@34Y@#8deepmatka",
            user_id: 0,
            player_id: 0
        };
        dispatch(homePageActions.dashboardDataRequest(data))
        dispatch(homePageActions.sliderDataRequest(data))
        const datacon: any = { "app_key": "@34Y@#8deepmatka" }
        dispatch(homePageActions.contactDataRequest(datacon))
        
        // Fetch Starline games
        const starlineData: any = {
            app_key: "@34Y@#8deepmatka",
        };
        dispatch(starlineActions.starLineDataReq(starlineData))
    }

    const handleWhatsAppClick = () => {
        const whatsappNumber = get(contactData, 'whatsapp_no', '') || get(contactData, 'mobile_1', '');
        if (whatsappNumber) {
            window.open(`https://api.whatsapp.com/send?phone=${whatsappNumber}&text=Hello_Support_Team`, '_blank');
        }
    }

    const handleTelegramClick = () => {
        // Option 1: Use URL from API/database (recommended - change in database table tb19)
        // const telegramLink = get(contactData, 'telegram', '');
        
        // Option 2: Hardcode URL directly (uncomment below and comment above if you want to hardcode)
         const telegramLink = 'https://t.me/cmmkolkata'; // Replace with your Telegram channel/group URL
        
        if (telegramLink) {
            window.open(telegramLink, '_blank');
        }
    }

    // const colorList: any = {
    //     1: '#ffce85', 2: '#fb9090', 3: '#dcdcf9', 4: '#69b9f9', 5: '#61cdc3', 6: '#ffdacc', 7: '#fbbfa8', 8: '#f9b69c', 9: '#d9efff', 10: '#cae7fb', 11: '#b9e2fd', 12: '#fbe5ff', 13: '#fae0ff', 14: '#f8d5ff', 15: '',
    // }

    const colorList: any = {
        1: '#f7ae2b', 2: '#fb9090', 3: '#dcdcf9', 4: '#69b9f9', 5: '#61cdc3', 6: '#ffdacc', 7: '#ffdacc', 8: '#ffdacc', 9: '#ffdacc', 10: '#ffdacc', 11: '#ffdacc', 12: '#ffdacc', 13: '#ffdacc', 14: '#ffdacc', 15: '',
    }
    const fabStyle = {
        position: 'absolute',
        bottom: 100,
        right: 10,
        // width: '115px',
        // height: '79px',
        // display: 'flex',
        // flexDirection: 'column',
        // fontSize: '11px',
        // padding: '15px'
      };
      

    return (
        <div>
            <Container sx={{ paddingLeft: '0px !important', paddingRight: '0px !important', marginTop: '0px !important', backgroundColor: theme.palette.background.default }}>
               
                
                <Grid container sx={{
                    position: 'fixed',
                    padding: '0px 10px 0px 10px', display: 'flex', flexDirection: 'column', marginLeft: {
                        // xs:0,
                        // lg:10,
                        // md:10,
                        // xl:10,
                        // sm:8
                    }
                }} gap={'0px'}>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: '2px' }}>
                        <IconButton
                            onClick={() => navigate('/regular-games')}
                            sx={{
                                borderRadius: '16px', 
                                height: 'auto', 
                                width: '100%', 
                                background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
                                display: 'flex', 
                                justifyContent: 'flex-start', 
                                alignItems: 'center', 
                                boxShadow: '0 4px 15px rgba(74, 144, 226, 0.2)',
                                padding: '12px 20px',
                                '&:hover': {
                                    transform: 'translateY(-2px)',
                                    boxShadow: '0 6px 20px rgba(74, 144, 226, 0.3)',
                                },
                                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                            }}>
                            
                            <Box sx={{
                                display:'flex', 
                                justifyContent:'center', 
                                alignItems:'center', 
                                height:'45px', 
                                width:'45px', 
                                borderRadius:'12px', 
                                backgroundColor:'rgba(255,255,255,0.25)', 
                                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                backdropFilter: 'blur(10px)',
                            }}>
                                <PlayArrowRounded sx={{color: '#FFFFFF', fontSize: '1.8rem'}}/> 
                            </Box>
                            <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-start', paddingLeft: '12px' }}>
                                <Typography sx={{ color: '#FFFFFF', fontFamily: 'Poppins', fontSize: '1.25rem', fontWeight: '700', lineHeight: 1.2, textShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>Regular Games</Typography>
                                {/* <Typography sx={{ fontFamily: 'cursive', color: '#4d62a5', fontSize: '1.2rem' }}>Games</Typography> */}
                            </Box>
                        </IconButton>
                        {/* <IconButton
                            onClick={() => navigate('/starline')}
                            sx={{
                                borderRadius: '22px', height: 'auto', width: '50%', backgroundColor: colorList[1],
                                display: 'flex', justifyContent: 'flex-start', alignItems: 'center', boxShadow: '0px 0px 2px #adadad27'
                            }}>
                           <div style={{display:'flex', justifyContent:'center', alignItems:'center', height:'30px', width:'30px', borderRadius:'30px', backgroundColor:'#ffff'}}><PlayArrowRounded/> </div>
                            <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-start', paddingLeft: '10px' }}>
                                <Typography sx={{ color: '#5d5d5d', fontFamily: 'open sans', fontSize: '1.2rem', fontWeight: '800', lineHeight: 1 }}>King Starline</Typography>
                                {/* <Typography sx={{ fontFamily: 'cursive', color: '#4d62a5', fontSize: '1.2rem' }}>Games</Typography> */}
                           {/*} </Box>
                        </IconButton> */}
                    </Box>    
                  {/*  <Box sx={{ display: 'flex', marginLeft:'10px', alignItems: 'center', justifyContent: 'flex-start', gap: '10px', marginTop:'10px' }}>
                            <a style={{ textDecoration: 'none', display:'flex', gap:'5px' }} href={`https://api.whatsapp.com/send?phone='${get(contactData,'mobile_1','')}'&text=Contact us`}><div style={{display:'flex', justifyContent:'center', alignItems:'center', height:'20px', width:'20px', borderRadius:'30px', backgroundColor:'#2aa320'}}> <WhatsApp sx={{color:'#ffff', height:'15px', width:'15px'}} /></div> {get(contactData,'whatsapp_no','')}</a>
                            <Typography sx={{display:'flex', alignItems:'center', gap:'5px'}}><div style={{display:'flex', justifyContent:'center', alignItems:'center', height:'20px', width:'20px', borderRadius:'30px', backgroundColor:'#2aa320'}}> <Call sx={{color:'#ffff', height:'15px', width:'15px'}} /></div>  {get(contactData,'whatsapp_no','')} </Typography>
                    </Box>               */}
                </Grid>



                {/* <ImageList
                    sx={{ width: '100%', height: 'auto' }}
                    variant="quilted"

                >
                    {sliderData.map((item: any) => (
                        <ImageListItem key={item.image_id} cols={item.cols || 12} rows={item.rows || 12}>
                            <img
                                src={item.slider_image}
                                alt={item.image_id}
                                loading="lazy"
                            />
                        </ImageListItem>
                    ))}
                </ImageList> */}
                {/* </Container> */}
                {isHomeLoading ? <div style={{ width: '100%', height: '90vh', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'row' }}> <CircularProgress sx={{ color: theme.palette.primary.main }} /> </div> :
                    <Container sx={{ paddingLeft: '0px !important', paddingRight: '0px !important', paddingTop: '0px !important', position: 'absolute', marginTop: '90px', height: 'calc(100vh - 240px)', overflowY: 'scroll' }} >
                        
                        {/* Starline Games Section */}
                        {starlineGames.length > 0 && (
                            <Box sx={{ padding: '10px', marginBottom: '20px' }}>
                                <Typography sx={{ 
                                    fontSize: '1.75rem', 
                                    fontWeight: '700', 
                                    color: theme.palette.primary.main, 
                                    marginBottom: '20px',
                                    textAlign: 'center',
                                    fontFamily: 'Poppins',
                                    background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
                                    WebkitBackgroundClip: 'text',
                                    WebkitTextFillColor: 'transparent',
                                    letterSpacing: '0.5px',
                                }}>
                                    ⭐ Cmm Kolkata Fatafat
                                </Typography>
                                <Grid container sx={{ display: 'flex', justifyContent: 'flex-start', padding: '5px' }}>
                                    {starlineGames.map((item: any, index: number) => (
                                        <Grid xs={12} lg={3} md={4} sm={4} margin={1} key={`starline-${index}`}>
                                            <Card variant="outlined"
                                                onClick={(event: any) => handleStarlineGameClick(event, item)}
                                                sx={{
                                                    borderRadius: '20px',
                                                    boxShadow: '0 4px 20px rgba(74, 144, 226, 0.12)',
                                                    border: `1px solid ${theme.palette.divider}`,
                                                    padding: '20px',
                                                    backgroundColor: theme.palette.background.paper,
                                                    cursor: 'pointer',
                                                    position: 'relative',
                                                    overflow: 'hidden',
                                                    '&::before': {
                                                        content: '""',
                                                        position: 'absolute',
                                                        top: 0,
                                                        left: 0,
                                                        right: 0,
                                                        height: '4px',
                                                        background: `linear-gradient(90deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
                                                        opacity: 0,
                                                        transition: 'opacity 0.3s ease',
                                                    },
                                                    '&:hover': {
                                                        transform: 'translateY(-6px)',
                                                        boxShadow: '0 8px 30px rgba(74, 144, 226, 0.2)',
                                                        borderColor: theme.palette.primary.light,
                                                        '&::before': {
                                                            opacity: 1,
                                                        },
                                                    },
                                                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                                }}>
                                                <Box sx={{ 
                                                    display: 'flex', 
                                                    color: theme.palette.text.primary, 
                                                    padding: '5px', 
                                                    flexDirection: 'row', 
                                                    justifyContent: 'space-between', 
                                                    alignItems: 'center' 
                                                }}>
                                                    <Box sx={{ display: 'flex', flexDirection: 'column', padding: '0px 8px 0px 8px', alignItems: 'flex-start', justifyContent: 'flex-start' }}>
                                                        <Typography sx={{ 
                                                            textAlign: 'center', 
                                                            color: theme.palette.text.primary, 
                                                            fontFamily: 'Poppins', 
                                                            fontSize: '1.8rem', 
                                                            fontWeight: '800', 
                                                            lineHeight: 1 
                                                        }}>
                                                            {item.game_name}
                                                        </Typography>
                                                        <Box sx={{ marginTop: '8px', display: 'flex', flexDirection: 'row', paddingLeft: '5px', alignItems: 'center', justifyContent: 'center' }}>
                                                        <Typography sx={{ 
                                                            color: theme.palette.primary.main, 
                                                            fontFamily: 'Poppins', 
                                                            fontSize: '1.3rem', 
                                                            fontWeight: '700', 
                                                            lineHeight: 1,
                                                            letterSpacing: '2px',
                                                            background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
                                                            WebkitBackgroundClip: 'text',
                                                            WebkitTextFillColor: 'transparent',
                                                        }}>
                                                            {(item.open_result != '') ? item.open_result : '***-*'}
                                                        </Typography>
                                                        </Box>
                                                        <Box sx={{ marginTop: '8px', display: 'flex', flexDirection: 'column', paddingLeft: '5px', alignItems: 'flex-start', justifyContent: 'center', gap: '4px' }}>
                                                            <Typography sx={{ color: theme.palette.text.secondary, fontFamily: 'Poppins', fontSize: '0.85rem', fontWeight: '500', lineHeight: 1 }}>
                                                                Result Time: {item.open_time}
                                                            </Typography>
                                                            {(() => {
                                                                const remaining = getRemainingTime(item.open_time);
                                                                return remaining && item.msg_status === 1 ? (
                                                                    <Box sx={{
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        gap: '6px',
                                                                        padding: '4px 8px',
                                                                        borderRadius: '8px',
                                                                        backgroundColor: theme.palette.mode === 'light' 
                                                                            ? 'rgba(74, 144, 226, 0.1)' 
                                                                            : 'rgba(74, 144, 226, 0.2)',
                                                                        border: `1px solid ${theme.palette.primary.light}`,
                                                                    }}>
                                                                        <TimerIcon style={{ width: '14px', height: '14px', color: theme.palette.primary.main }} />
                                                                        <Typography sx={{ 
                                                                            color: theme.palette.primary.main, 
                                                                            fontFamily: 'Poppins', 
                                                                            fontSize: '0.75rem', 
                                                                            fontWeight: '700', 
                                                                            lineHeight: 1,
                                                                            letterSpacing: '0.5px',
                                                                        }}>
                                                                            Bid Remain: {remaining.formatted}
                                                                        </Typography>
                                                                    </Box>
                                                                ) : null;
                                                            })()}
                                                        </Box>
                                                    </Box>
                                                    <IconButton sx={{
                                                        borderRadius: '18px', height: '100px', width: '100px', padding: 0,
                                                        display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center', boxShadow: '0px 0px 0px #adadad27'
                                                    }}>
                                                        {(item.msg_status === 1) ? 
                                                            <Typography sx={{ fontSize: '10px', color: theme.palette.success.main, marginBottom: '5px', fontWeight: 700 }}>● OPEN</Typography> : 
                                                            <Typography sx={{ fontSize: '9px', color: theme.palette.error.main, marginBottom: '2px', fontWeight: 700 }}>● CLOSED</Typography>
                                                        }
                                                        <Box sx={{ 
                                                            display: 'flex', 
                                                            justifyContent: 'center', 
                                                            alignItems: 'center', 
                                                            height: '55px', 
                                                            width: '55px', 
                                                            borderRadius: '16px', 
                                                            background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
                                                            boxShadow: '0 4px 15px rgba(74, 144, 226, 0.3)',
                                                            transition: 'all 0.3s ease',
                                                        }}>
                                                            <PlayArrowRounded sx={{ fontSize: '2.2rem', color: '#FFFFFF' }} /> 
                                                        </Box>
                                                        <Typography sx={{ fontSize: '9px', color: theme.palette.text.secondary, marginBottom: '0px', marginTop: '5px', fontWeight: 600 }}>Play game</Typography>
                                                    </IconButton>
                                                </Box>
                                            </Card>
                                        </Grid>
                                    ))}
                                </Grid>
                            </Box>
                        )}

                        {/* Regular Games Button - Redirect to /regular-games */}
                        {pageData.length > 0 && (
                            <Box sx={{ padding: '10px', textAlign: 'center', marginTop: '20px' }}>
                                <Button
                                    fullWidth
                                    variant="contained"
                                    startIcon={<PlayArrowRounded />}
                                    onClick={() => navigate('/regular-games')}
                                    sx={{
                                        background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
                                        color: 'white',
                                        padding: '15px',
                                        fontSize: '1.2rem',
                                        fontWeight: 'bold',
                                        borderRadius: '15px',
                                        boxShadow: theme.shadows[4],
                                        fontFamily: 'Poppins',
                                        '&:hover': {
                                            transform: 'translateY(-2px)',
                                            boxShadow: theme.shadows[8],
                                        }
                                    }}
                                >
                                    🎮 View Regular Games ({pageData.length})
                                </Button>
                            </Box>
                        )}

                        {/* No data message */}
                        {!isHomeLoading && !isStarLineLoading && pageData.length === 0 && starlineGames.length === 0 && (
                            <Box sx={{ padding: '50px', textAlign: 'center' }}>
                                <Typography sx={{ fontFamily: 'Poppins' }}>No games available</Typography>
                            </Box>
                        )}


                    </Container>}

                <CustomModal open={openModal} customstyle={{ 
                    width: '250px', 
                    backgroundColor: theme.palette.background.paper, 
                    padding: '20px',
                    borderRadius: '20px',
                    border: `2px solid ${theme.palette.primary.main}`,
                }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography sx={{ fontSize: '18px', color: theme.palette.primary.main, fontWeight: 700, fontFamily: 'Poppins' }}>Contact us</Typography>
                        <CloseOutlined onClick={closePopup} sx={{ cursor: 'pointer', textAlign: 'right', color: theme.palette.primary.main, height: '24px', width: '24px', '&:hover': { transform: 'scale(1.1)' }, transition: 'all 0.3s ease' }} />
                    </Box>

                    <Box sx={{
                        display: 'flex', marginTop: '15px', bottom: 0, justifyContent: 'center', alignItems: 'center', marginBottom: '10px', gap: 3,
                        backgroundColor: theme.palette.mode === 'light' ? 'rgba(255, 107, 53, 0.1)' : 'rgba(255, 0, 110, 0.1)',
                        padding: '15px',
                        borderRadius: '20px',
                        color: theme.palette.primary.main,
                    }}>
                        {/* <a href={`https://api.whatsapp.com/send?phone='${contactData.whatsapp_no}'&text=Contact us`} title="Share on whatsapp">{contactData.whatsapp_no}</a> */}
                        {/* <WhatsApp sx={{ cursor: 'pointer' }} onClick={() => window.location.href = 'https://api.whatsapp.com/send?phone='+contactData.whatsapp_no+'&text=Contact us'} /> */}
                        {/* <Telegram sx={{ cursor: 'pointer' }} onClick={() => window.location.href = contactData.telegram} /> */}
                        {/* <Call sx={{ cursor: 'pointer' }} onClick={() => window.location.href = 'https://api.whatsapp.com/send?phone='+contactData.whatsapp_no+'&text=Contact us'} /> */}
                        <a style={{ textDecoration: 'none' }} href={`https://api.whatsapp.com/send?phone='${contactData.whatsapp_no}'&text=Contact us`}><WhatsApp sx={{ cursor: 'pointer', color: theme.palette.success.main, fontSize: '2rem', '&:hover': { transform: 'scale(1.2)' }, transition: 'all 0.3s ease' }} /></a>
                        <a href={contactData.whatsapp_no} style={{ textDecoration: 'none' }}><Telegram sx={{ cursor: 'pointer', color: theme.palette.info.main, fontSize: '2rem', '&:hover': { transform: 'scale(1.2)' }, transition: 'all 0.3s ease' }} /></a>
                        <a href={contactData.whatsapp_no} style={{ textDecoration: 'none' }}><Call sx={{ cursor: 'pointer', color: theme.palette.secondary.main, fontSize: '2rem', '&:hover': { transform: 'scale(1.2)' }, transition: 'all 0.3s ease' }} /></a>
                    </Box>
                </CustomModal>  
                <AlertBar handleClose={handleClose} errorMessage={errorMessage} />
                
                {/* Fixed Position Buttons */}
                {/* Left Side - WhatsApp and Telegram */}
                <Box sx={{
                    position: 'fixed',
                    left: { xs: '10px', sm: '15px', md: '20px' },
                    bottom: { xs: '80px', sm: '100px' },
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '12px',
                    zIndex: 1000,
                }}>
                    {/* WhatsApp Button */}
                    <IconButton
                        onClick={handleWhatsAppClick}
                        sx={{
                            backgroundColor: '#25D366',
                            color: '#FFFFFF',
                            width: { xs: '50px', sm: '56px' },
                            height: { xs: '50px', sm: '56px' },
                            boxShadow: '0 4px 15px rgba(37, 211, 102, 0.4)',
                            '&:hover': {
                                backgroundColor: '#20BA5A',
                                transform: 'scale(1.1)',
                                boxShadow: '0 6px 20px rgba(37, 211, 102, 0.5)',
                            },
                            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                        }}
                        aria-label="WhatsApp Chat"
                    >
                        <WhatsApp sx={{ fontSize: { xs: '1.8rem', sm: '2rem' } }} />
                    </IconButton>

                    {/* Telegram Button */}
                    <IconButton
                        onClick={handleTelegramClick}
                        sx={{
                            backgroundColor: '#0088cc',
                            color: '#FFFFFF',
                            width: { xs: '50px', sm: '56px' },
                            height: { xs: '50px', sm: '56px' },
                            boxShadow: '0 4px 15px rgba(0, 136, 204, 0.4)',
                            '&:hover': {
                                backgroundColor: '#0077B5',
                                transform: 'scale(1.1)',
                                boxShadow: '0 6px 20px rgba(0, 136, 204, 0.5)',
                            },
                            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                        }}
                        aria-label="Telegram Channel"
                    >
                        <Telegram sx={{ fontSize: { xs: '1.8rem', sm: '2rem' } }} />
                    </IconButton>
                </Box>

                {/* Right Side - Refresh Button */}
                <IconButton
                    onClick={handleRefresh}
                    sx={{
                        position: 'fixed',
                        right: { xs: '10px', sm: '15px', md: '20px' },
                        bottom: { xs: '80px', sm: '100px' },
                        backgroundColor: theme.palette.background.paper,
                        color: theme.palette.primary.main,
                        width: { xs: '50px', sm: '56px' },
                        height: { xs: '50px', sm: '56px' },
                        border: `2px solid ${theme.palette.primary.main}`,
                        boxShadow: theme.shadows[4],
                        zIndex: 1000,
                        '&:hover': {
                            backgroundColor: theme.palette.primary.main,
                            color: '#FFFFFF',
                            transform: 'rotate(180deg) scale(1.1)',
                            boxShadow: theme.shadows[8],
                        },
                        transition: 'all 0.5s cubic-bezier(0.4, 0, 0.2, 1)',
                    }}
                    aria-label="Refresh"
                >
                    <Refresh sx={{ fontSize: { xs: '1.8rem', sm: '2rem' } }} />
                </IconButton>

                {!isVisible ? '': <Fab sx={{
                    ...fabStyle,
                    background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
                    color: '#FFFFFF',
                    boxShadow: theme.shadows[6],
                    '&:hover': {
                        transform: 'scale(1.1)',
                        boxShadow: theme.shadows[8],
                    }
                }} aria-label="add" onClick={promptToInstall}>
                    <AddIcon  />                    
                </Fab>}
                
            </Container>
        </div>
    )
}

const mapStateToProps = (state: any) => ({
    homePageData: state.homepage.homePageData,
    isHomeLoading: state.homepage.isHomeLoading,
    isCheckGameStatusLoading: state.homepage.isCheckGameStatusLoading,
    gameStatusData: state.homepage.gameStatusData,
    isCheckGameStatusFailed: state.homepage.isCheckGameStatusFailed,
    isCheckGameStatusSuccess: state.homepage.isCheckGameStatusSuccess,
    sliderData: state.homepage.sliderData,
    contactData: state.homepage.contactData,
    isStarLineLoading: state.starline.isStarLineLoading,
    starLineData: state.starline.starLineData,
})


export default connect(mapStateToProps)(Home);